<div class="h-full min-h-0 overflow-auto">
  <div class="flex gap-2 items-center mb-4">
    <app-input-buscador
      placeholder="Buscar tipo de pago..."
      [(valor)]="busquedaTipoPago"
      class="flex-1"
      (presionaEnter)="onBuscarTipoPago()"
    />
    <app-button
      label="Nuevo Tipo de Pago"
      icon="bi bi-plus"
      variant="primary"
      (onClick)="modal_crear_tipo_pago.set(true)"
    />
  </div>
  <div class="grid grid-cols-[repeat(auto-fill,minmax(250px,1fr))] gap-4">
    @for (tipoPago of tipoPagos(); track $index) {
      <app-card-tipo-pago [tipoPago]="tipoPago" />
    } @empty {
      <div class="col-span-full text-center text-slate-500 py-10">
        No se encontraron tipos de pago.
      </div>
    }
  </div>
</div>

<app-dialog
  header="Crear tipo de pago"
  [modal]="true"
  [(visible)]="modal_crear_tipo_pago"
  (onHide)="modal_crear_tipo_pago.set(false)"
  size="md"
>
  @if (modal_crear_tipo_pago()) {
    <app-crear-tipo-pago (cerrar)="closeCrearTipoPago($event)"></app-crear-tipo-pago>
  }
</app-dialog>
